export class AddPointCommand {
    _road;
    _newPointPos;
    _pointID;
    _roadEditCallback;
    constructor(road, point, roadEditCallback) {
        this._road = road;
        this._newPointPos = point;
        this._roadEditCallback = roadEditCallback;
    }
    async execute(viewer) {
        this._pointID = await this._road.addIPPointAtEnd(this._newPointPos);
        await this._roadEditCallback?.();
    }
    async undo(viewer) {
        await this._road.removeControlPoint(this._pointID);
        await this._roadEditCallback?.();
    }
}
export class RemovePointCommand {
    _road;
    _pos;
    _removedPointID;
    _callback;
    _index;
    // Pre-delete copy of the vertical alignment, restored on undo
    _pviSnapshot = [];
    constructor(road, pointID, callback) {
        this._road = road;
        this._removedPointID = pointID;
        this._callback = callback;
    }
    async execute(viewer) {
        this._pos = this._road.getControlPointPos(this._removedPointID);
        this._index = this._road.getControlPointIndex(this._removedPointID);
        this._pviSnapshot = this._road.getPviSnapshot();
        await this._road.removeControlPoint(this._removedPointID);
        await this._callback?.();
    }
    async undo(viewer) {
        // Restore with the same ID so that redo removes the same IP point
        await this._road.restoreControlPointAtIndex(this._index, this._pos, this._removedPointID, this._pviSnapshot);
        await this._callback?.();
    }
}
export class UpdatePointPositionCommand {
    _road;
    _newPointPos;
    _oldPos;
    _pointID;
    _callback;
    constructor(road, newPos, pointID, callback) {
        this._road = road;
        this._newPointPos = newPos;
        this._pointID = pointID;
        this._callback = callback;
    }
    async execute(viewer) {
        this._oldPos = await this._road.updateControlPointPosition(this._newPointPos, this._pointID);
        await this._callback?.();
    }
    async undo(viewer) {
        await this._road.updateControlPointPosition(this._oldPos, this._pointID);
        await this._callback?.();
    }
}
export class UpdateHorizontalAlignmentTypeCommand {
    _road;
    _horizontalAlignmentType;
    _oldHorizontalAlignmentType;
    _callback;
    constructor(road, horizontalAlignmentType, callback) {
        this._road = road;
        this._horizontalAlignmentType = horizontalAlignmentType;
        this._callback = callback;
    }
    async execute(viewer) {
        this._oldHorizontalAlignmentType =
            this._road.alignment.horizontalAlignment.type;
        await this._road.setTypeToHorizontalAlignment(this._horizontalAlignmentType);
        await this._callback?.();
    }
    async undo(viewer) {
        await this._road.setTypeToHorizontalAlignment(this._oldHorizontalAlignmentType);
        await this._callback?.();
    }
}
export class AddControlPointOnRoadCommand {
    _road;
    _controlPointID;
    _callback;
    _pointID;
    constructor(road, controlPointID, callback) {
        this._road = road;
        this._controlPointID = controlPointID;
        this._callback = callback;
    }
    async execute(viewer) {
        this._pointID = await this._road.addIPPointOnRoad(this._controlPointID);
        await this._callback?.();
    }
    async undo(viewer) {
        await this._road.removeControlPoint(this._pointID);
        await this._callback?.();
    }
}
export class AddControlPointAtIndexCommand {
    _road;
    _index;
    _callback;
    _point;
    _pointID;
    constructor(road, index, point, callback) {
        this._road = road;
        this._index = index;
        this._point = point;
        this._callback = callback;
    }
    async execute(viewer) {
        this._pointID = await this._road.addIPPointAtIndex(this._index, {
            localPosition: this._point,
        });
        await this._callback?.();
    }
    async undo(viewer) {
        await this._road.removeControlPoint(this._pointID);
        await this._callback?.();
    }
}
export class UpdateSlopeBreaksInLongitudinalView {
    _road;
    _callback;
    _oldSlopeBreaks;
    _slopeBreaks;
    constructor(road, slopeBreaks, callback) {
        this._road = road;
        this._slopeBreaks = slopeBreaks;
        this._callback = callback;
    }
    async execute(viewer) {
        const length = this._road.alignment.lengthOnDatum;
        this._oldSlopeBreaks = this._road.verticalAlignmentData.map((va) => ({
            percentage: va.horizontalDistance / length,
            height: va.elevation,
            isActive: va.isActive,
        }));
        const updateViewer = this._road.isVisible();
        await this._road.updateSlopeBreak(this._slopeBreaks, updateViewer);
        if (updateViewer) {
            await this._callback?.();
        }
    }
    async undo(viewer) {
        const updateViewer = this._road.isVisible();
        await this._road.updateSlopeBreak(this._oldSlopeBreaks, updateViewer);
        if (updateViewer) {
            await this._callback?.();
        }
    }
}
//# sourceMappingURL=road-commands.js.map